import React from "react";
import { useNavigate, Link } from 'react-router-dom'
import HoverImage from "react-hover-image";
import '../Component/css/Portfolio.css'

import a from '../assets/NewImage2/A1.webp'
import b from '../assets/NewImage2/A2.webp'
import d from '../assets/NewImage2/A4.webp'
import e from '../assets/NewImage2/A5.webp'
import f from '../assets/NewImage2/A6.webp'
import g from '../assets/NewImage2/A7.webp'
// newly added on March 8th 2023
import h from '../assets/NewImage2/A8.webp'
import i from '../assets/NewImage2/A9.webp'
import j from '../assets/NewImage2/A10.webp'
import k from '../assets/NewImage2/A11.webp'
import l from '../assets/NewImage2/A12.webp'

import a1 from '../assets/New image/a.webp'
import b1 from '../assets/New image/b.webp'
import d1 from '../assets/New image/d.webp'
import e1 from '../assets/New image/e.webp'
import f1 from '../assets/New image/f.webp'
import g1 from '../assets/New image/g.webp'
// newly added on March 8th 2023
import h1 from '../assets/New image/h.webp'
import i1 from '../assets/New image/i.webp'
import j1 from '../assets/New image/j.webp'
import k1 from '../assets/New image/k.webp'
import l1 from '../assets/New image/l.webp'


function Portfolio() {
    const navigate = useNavigate()
    return (
        <div className="portfolio">
            <section className="portofolio-section sec-padding">
                <div className="container">
                    <div className="row">
                        <div className="section-title">
                            <h2>Recent Projects.</h2>                           
                        </div>
                    </div>
                    
                        {/* WEB DEVELOPMENT PROJECT */}
                    <div className="project-row">

                        {/* ADMOS*/}
                        <div className="portfolio-item">
                            <div className="portfolio-item-thumbnail hoverImg">
                                <a href="https://www.behance.net/gallery/160910009/Admos-Hotel-UIUX-Design-and-Development-Casestudy" target="_blank">
                                    <HoverImage id="one" src={h}  hoverSrc={h1} alt="" /> 
                                </a>
                            </div>
                        </div> 

                        {/* PANION*/}
                        <div className="portfolio-item">
                            <div className="portfolio-item-thumbnail hoverImg" onClick={() => navigate('/Panion')}>
                                <HoverImage id="one" src={g}  hoverSrc={g1} alt="" /> 
                            </div>
                        </div> 

                        {/* ASTROTECHLABS
                        <div className="portfolio-item">
                            <div className="portfolio-item-thumbnail hoverImg">
                                <a href="https://astro-tech-labs.vercel.app/">
                                    <HoverImage id="one" src={i}  hoverSrc={i1} alt="" /> 
                                </a>
                            </div>
                        </div>  */}

                        {/* V STREAMS */}
                        <div className="portfolio-item">
                            <div className="portfolio-item-thumbnail hoverImg" onClick={() => navigate('/Vstream')}>
                                <HoverImage id="one" src={b}  hoverSrc={b1} alt="" /> 
                            </div>
                        </div>

                        {/* GREEN FIELD */}
                        <div className="portfolio-item" onClick={() => navigate('/Green')}>
                            <div className="portfolio-item-thumbnail hoverImg">
                            <HoverImage id="one" src={d}  hoverSrc={d1} alt="" /> 
                            </div>
                        </div> 

                        {/* INNOLOFT */}
                        <div className="portfolio-item">
                            <div className="portfolio-item-thumbnail hoverImg">
                                <a href="https://www.behance.net/gallery/164239117/Innoloft-redesign" target="_blank">
                                    <HoverImage id="one" src={k}  hoverSrc={k1} alt="" /> 
                                </a>
                            </div>
                        </div> 

                        {/* ONSALE */}
                        <div className="portfolio-item">
                            <div className="portfolio-item-thumbnail hoverImg">
                                <a href="https://www.behance.net/gallery/154520563/Ecommerce-Onsale" target="_blank">
                                    <HoverImage id="one" src={l}  hoverSrc={l1} alt="" /> 
                                </a>
                            </div>
                        </div> 

                        {/* KIA */}
                        <div className="portfolio-item">
                            <div className="portfolio-item-thumbnail hoverImg">
                                <a href="https://www.behance.net/gallery/159127767/Kia-Global-Rebrand" target="_blank">
                                    <HoverImage id="one" src={j}  hoverSrc={j1} alt="" /> 
                                </a>
                            </div>
                        </div> 

                        {/* TODO TASK APPLICATION */}
                        <div className="portfolio-item" onClick={() => navigate('/Todo')}>
                            <div className="portfolio-item-thumbnail hoverImg">
                                <HoverImage id="one" src={e}  hoverSrc={e1} alt="" /> 
                            </div>
                        </div>

                        {/* CHRISTMAS ANIMATION */}
                        <div className="portfolio-item">
                            <div className="portfolio-item-thumbnail hoverImg" onClick={() => navigate('/Tree')}>
                                <HoverImage id="one" src={a}  hoverSrc={a1} alt="" /> 
                            </div>
                        </div> 

    
                        {/* CLAVR HOME PAGE */}
                        <div className="portfolio-item" onClick={() => navigate('/Clavr')}>
                            <div className="portfolio-item-thumbnail hoverImg">
                            <HoverImage id="one" src={f}  hoverSrc={f1} alt="" /> 
                            </div>
                        </div> 
                    </div>  
                    
                    {/* End work Detail */}
                    <div onClick={() => navigate('/Contact')} className="go_to1">
                        <p>Let's work together</p> 
                        <div className="icon">
                            <i class="fas fa-angle-right"></i>
                            <i class="fas fa-angle-right"></i>
                        </div>
                    </div>
                </div>            
            </section>
        </div>
    )
} 

export default Portfolio
 